import VendorCommentsContainer from "./VendorCommentsContainer";
export default VendorCommentsContainer;
